const validaData = (data) => {
    let ldata   = data.split('/');
    let Year    = new Date();    

    if (ldata[0] > 31) {
        return false
    }
    if (ldata[1] > 12) {
        return false
    }
    if (ldata[2] > Year.getFullYear() || ldata[2] < 1800) {
        return false
    }

    return true
}

export default validaData;